/* hs-eslint ignored failing-rules */
/* eslint-disable hubspot-dev/no-confusing-browser-globals */

'use es6';

import PropTypes from 'prop-types';
import PortalIdParser from 'PortalIdParser';
import { Map as ImmutableMap } from 'immutable';
import AsyncReportActions from '../AsyncReportActions';
import { ReportLink } from '../../reportsView/shared/ReportLink';
import { useReportLinkProblem } from '../../../utils/useReportLinkProblem';
import { TableHoverCell } from 'foundations-components/transitional/components/Table';
import useReportTypeProblem from 'reporting-action-components/reportingActions/shared/problemHooks/useReportTypeProblem';
import { jsx as _jsx } from "react/jsx-runtime";
const ACCEPTANCE_TEST_PORTAL = 99689734;
const NameCell = ({
  onAddToDashboard,
  onClone,
  onUpdate,
  report
}) => {
  const isATPortal = PortalIdParser.get() === ACCEPTANCE_TEST_PORTAL; //Keep the actions dropdown open for acceptance test reliability
  const hoverContentProps = isATPortal ? {
    open: true
  } : {};
  const reportAccessProblem = useReportTypeProblem({
    report
  });
  const {
    problem,
    TooltipMessage
  } = useReportLinkProblem(report);
  return AsyncReportActions ? /*#__PURE__*/_jsx(TableHoverCell, {
    hoverContentProps: hoverContentProps,
    hoverContent: /*#__PURE__*/_jsx(AsyncReportActions, {
      isReportLocked: !!reportAccessProblem,
      onAddToDashboard: onAddToDashboard,
      onClone: onClone,
      onUpdate: onUpdate,
      report: report
    }),
    children: /*#__PURE__*/_jsx(ReportLink, {
      report: report,
      problem: problem,
      TooltipMessage: TooltipMessage
    })
  }) : /*#__PURE__*/_jsx("td", {
    children: /*#__PURE__*/_jsx(ReportLink, {
      report: report,
      problem: problem,
      TooltipMessage: TooltipMessage
    })
  });
};
NameCell.propTypes = {
  report: PropTypes.instanceOf(ImmutableMap).isRequired,
  onClone: PropTypes.func.isRequired,
  onUpdate: PropTypes.func.isRequired,
  onAddToDashboard: PropTypes.func.isRequired
};
export default NameCell;